import { Component, OnInit } from '@angular/core';
import { AnnouncementService, MemberQuery, MixedLoyaltyItem, MixedLoyaltyQuery, Scorecard, ScorecardQuery } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { map, Observable } from 'rxjs';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit {
  name$: Observable<string>;
  scorecard$: Observable<Scorecard[]>;
  mixedLoyaltyItems$: Observable<MixedLoyaltyItem[]>;
  screenType = ScreenType;
  populations = Populations;

  constructor(
    private memberQuery: MemberQuery,
    private scorecardQuery: ScorecardQuery,
    private mixedLoyaltyService: MixedLoyaltyQuery,
    private announcementService: AnnouncementService
  ) {}

  ngOnInit() {
    this.name$ = this.memberQuery.selectMemberDetails().pipe(
      map((m) => {
        if (m) {
          return `${m.FirstName}`;
        }
        return '';
      })
    );

    this.scorecard$ = this.scorecardQuery.selectAllScorecardSorted();
    this.mixedLoyaltyItems$ = this.mixedLoyaltyService.selectFavouriteMixedLoyaltyItems();
    this.announcementService.fetchAnnouncements().toPromise();
  }
}
